import React, { useRef, useState } from "react";
import DataGrid, { Column, HeaderFilter, Paging, Pager, ColumnChooser, FilterRow } from "devextreme-react/data-grid";
import { Button } from "devextreme-react/button";
import { formatDate } from "../../Dateapi/dateFormatter";
import { CheckBox, SelectBox } from "devextreme-react";

export default function QueryResultsGrid({ rows, columns, onColumnsChanged }) {
  const dataGrid = useRef(null);

  const [showFilterRow, setShowFilterRow] = useState(false);
  const [showHeaderFilter, setShowHeaderFilter] = useState(true);
  const [currentFilter, setCurrentFilter] = useState("auto");

  const applyFilterTypes = [
    { key: "auto", name: "Immediately" },
    { key: "onClick", name: "On Button Click" },
  ];

  const syncColumns = () => {
    const grid = dataGrid.current?.instance();
    if (!grid) return;

    const visibleColumns = grid
      .getVisibleColumns()
      .filter((col) => col.dataField)
      .map((col) => ({
        dataField: col.dataField,
        caption: col.caption || col.dataField,
        visibleIndex: col.visibleIndex,
        visible: col.visible !== false,
      }));

    onColumnsChanged?.(visibleColumns);
  };

  return (
    <div className="card">
      <div className="section-header">
        <h3>Results</h3>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          marginBottom: "10px",
          flexWrap: "wrap",
        }}
      >
        <Button
          icon="column-chooser"
          stylingMode="outlined"
          type="normal"
          onClick={() => dataGrid.current.instance().showColumnChooser()}
        />

        <div className="Table2Options display-flex-div" style={{ gap: "12px", alignItems: "center" }}>
          <p className="go-to-label-filed" style={{ fontWeight: 600 }}>
            Apply Filter
          </p>

          <SelectBox
            items={applyFilterTypes}
            value={currentFilter}
            onValueChanged={(e) => setCurrentFilter(e.value)}
            valueExpr="key"
            displayExpr="name"
            disabled={!showFilterRow}
            style={{ width: "150px" }}
          />

          <CheckBox text="Filter Row" value={showFilterRow} onValueChanged={(e) => setShowFilterRow(e.value)} />

          <CheckBox
            text="Header Filter"
            value={showHeaderFilter}
            onValueChanged={(e) => setShowHeaderFilter(e.value)}
          />
        </div>
      </div>

      <DataGrid
        ref={dataGrid}
        dataSource={rows}
        showBorders={true}
        columnAutoWidth={true}
        allowColumnResizing={true}
        rowAlternationEnabled={true}
        style={{
          maxHeight: "400px",
        }}
        allowColumnReordering={true}
        onOptionChanged={(e) => {
          if (
            e.fullName?.includes("visibleIndex") ||
            e.fullName?.includes("visible") ||
            e.fullName?.includes("columns")
          ) {
            setTimeout(syncColumns, 0);
          }
        }}
        onContentReady={syncColumns}
      >
        <FilterRow visible={showFilterRow} applyFilter={currentFilter} />
        <HeaderFilter visible={showHeaderFilter} allowSearch={true} />

        <ColumnChooser height="340px" width="400px" enabled={true} mode="dragAndDrop" />

        <Paging defaultPageSize={20} />

        <Pager showPageSizeSelector={true} allowedPageSizes={[10, 20, 30, 50]} showInfo={true} />

        {columns.map((col) => {
          const actualField =
            rows?.[0] && Object.keys(rows[0]).find((key) => key.toLowerCase() === col.dataField.toLowerCase());

          const valueField = actualField || col.dataField;

          const isDateColumn = valueField.toLowerCase().includes("dob") || col.caption?.toLowerCase().includes("date");

          return (
            <Column
              key={col.dataField}
              dataField={valueField}
              caption={col.caption}
              cellRender={({ data }) => {
                const value = data[valueField];

                if (isDateColumn) {
                  return formatDate(value);
                }

                return value ?? "-";
              }}
            />
          );
        })}
      </DataGrid>
    </div>
  );
}
